import { Array, Control, CustomPattern, MaxLength } from "@recursyve/ngx-form-generator";

export class CodeCharacterForm {
    @Control()
    @CustomPattern(/^[a-zA-Z0-9]{1}/, { invalid_character: true })
    @MaxLength(1)
    value: string;
}

export class RegisterOwnerCodeForm {
    @Array(() => CodeCharacterForm)
    characters: CodeCharacterForm[];

    public toCode(): string {
        return this.characters.map(character => character.value).join("");
    }
}
